import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IconWrapper = styled.div`
  border: 1px solid #ffc542;
  border-radius: 16px;
  width: 68px;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.p`
  font-weight: 900;
  font-size: 12px;
  color: #565566;
`;
